import { stripComments } from "./strip-comments/strip";

/**
 * Checks if a SQL query starts with EXPLAIN keyword after stripping comments and whitespace
 * @param query - The SQL query string to check
 * @returns true if the query starts with EXPLAIN (case-insensitive), false otherwise
 */
export function startsWithExplain(query: string): boolean {
  // Strip all comments from the query
  const queryWithoutComments = stripComments(query).trim();

  // Check if the remaining query starts with EXPLAIN (case-insensitive)
  return /^explain\b/i.test(queryWithoutComments);
}
